<template>
  <div class="audio-item">
    <div :class="['audio-cover', {play: playing}]">
      <img v-if="audioData.cover" :src="audioData.cover">
      <img v-else src="@/assets/img/audio/cover.jpg">
    </div>
    <div class="audio-control" @click="switchPlay">
      <div class="play" v-if="!playing"></div>
      <div class="pause" v-else></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    audioData: Object
  },
  computed: {
    ...mapState(["audio"]),
    playing() {
      return this.audioData.path === this.audio.src && !this.audio.inQueue
        ? this.audio.playing
        : false;
    },
    audioPlayer() {
      return this.$root.$children[0].$refs.audioplayer;
    }
  },
  methods: {
    ...mapMutations(["setAudio"]),
    switchPlay() {
      if (!this.playing) {
        this.setAudio({
          playing: true,
          inQueue: false,
          src: this.audioData.path
        });
        this.audioPlayer.play();
      } else {
        this.audioPlayer.pause();
        this.setAudio({ playing: false });
      }
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.audio-item {
  position: relative;
  @include center-x;
  width: 188px;
  height: 188px;
  background-image: url("~@/assets/img/audio/speaker.png");
  background-repeat: no-repeat;
  background-size: 100%;

  .audio-cover {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3D(-50%, -50%, 0);
    width: 122px;
    height: 122px;
    border-radius: 100%;
    overflow: hidden;

    &.play {
      animation: audioPlay 10s linear infinite;
      animation-fill-mode: both;
    }

    @keyframes audioPlay {
      0% {
        transform: translate3D(-50%, -50%, 0) rotateZ(0);
      }
      100% {
        transform: translate3D(-50%, -50%, 0) rotateZ(360deg);
      }
    }
  }

  .audio-control {
    position: absolute;
    width: 5rem;
    height: 5rem;
    padding: 1.25rem;
    @include center-xy;

    .play,
    .pause {
      width: 2.5rem;
      height: 2.5rem;
      border: 1px solid #fff;
      background-color: rgba(255, 255, 255, 0.45);
      border-radius: 100%;
    }

    .play::after {
      content: "";
      position: relative;
      left: 50%;
      margin-left: -0.125rem;
      @include center-y;
      display: block;
      width: 0px;
      height: 0px;
      border: 0.5rem transparent solid;
      border-left-color: #fff;
    }

    .pause {
      padding: 0.75rem 0;
      text-align: center;
      &::before,
      &::after {
        content: "";
        position: relative;
        display: inline-block;
        margin: 0 0.15rem;
        width: 0.25rem;
        height: 1rem;
        background-color: #fff;
      }
    }
  }

  &:after {
    content: "";
    position: absolute;
    display: block;
    bottom: -2rem;
    width: 100%;
    height: 1rem;
    background-image: url("~@/assets/img/swiper-active.png");
    background-size: 100%;
    background-repeat: no-repeat;
  }
}
</style>
